import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { FC } from 'react';

import { ParkingSpotsTable } from '../../containers';

export const ParkingSpots: FC = () => {
  const { t } = useTranslation();
  return (
    <HasPermission permissionFeature="PARKINGS" permissionType="READ" redirect>
      <Typography className="py-2 mb-4" variant="h300" element="h1">
        {t('PARKING_SPOTS.PAGE_TITLE')}
      </Typography>
      <ParkingSpotsTable />
    </HasPermission>
  );
};
